// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collapse .heading[data-v-1205cb4a]{cursor:pointer;padding-left:1em}.collapse .heading[data-v-1205cb4a]:before{content:"▸";margin-left:-1em;float:left;font-size:1em}.collapse.expanded .heading[data-v-1205cb4a]:before{content:"▾"}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
